<template>
  <div>
    <Card>
      <ui-update-info class="wrapper" :data="updateInfo"></ui-update-info>
    </Card>
    <Card>
      <ui-update-info class="wrapper" :data="updateInfo" infoFormat="short"></ui-update-info>
    </Card>
  </div>
</template>

<script setup lang="ts">
import Card from '@/stories/utils/card.vue';

import { computed } from 'vue';

const updateInfo = computed(() => {
  const today = new Date();
  return {
    updatedBy: 'Test name',
    updated: today,
    created: today,
  };
});
</script>

<style lang="scss" scoped>
.wrapper {
  width: fit-content;
}
</style>
